import type { IGetEventMetricsByIdResponseBody } from "~/feature/event/types";

interface IMetricValue {
  value: number | null;
  percentage?: number | null;
}

interface IPrepareEventMetricsParams {
  data?: IGetEventMetricsByIdResponseBody;
  isChangeUnavailable?: boolean;
}

const toMetric = (
  value: number | null,
  percentage: number | null,
  isChangeUnavailable: boolean
): IMetricValue => ({
  value,
  percentage: isChangeUnavailable ? undefined : percentage,
});

export const prepareEventMetrics = ({
  data,
  isChangeUnavailable = false,
}: IPrepareEventMetricsParams) => {
  if (!data) {
    return null;
  }

  return {
    totalVolume: { value: data.volume },
    volume24: toMetric(data.volume24, data.volume24pers, isChangeUnavailable),
    liquidity: toMetric(
      data.liquidity,
      data.liquidity24pers,
      isChangeUnavailable
    ),
    openInterest: toMetric(
      data.openInterest,
      data.openInterest24pers,
      isChangeUnavailable
    ),
  };
};
